import { useCallback, useEffect, useState } from "react";
import Button from "../../ui/Button";
import { AddIcon } from "../../utils/icon.utils";
import FormSectionTitle from "../../components/styled/FormSectionTitle";
import { arrayMap } from "../../utils/array.utils";
import RemoveVehicleShowroomWorksField from "./RemoveVehicleShowroomWorksField";
import FormSectionContainer from "../../components/Form/FormSectionContainer";
import { useGetAllCarInfoByCarInfoTypeSlug } from "../../utils/carInfo.utils";

export default function VehicleShowroomWorksField({
  watch,
  control,
  errors,
  unregister,
  setValue,
  others
}) {
  // get all shwroom works
  const { data: works, loading } = useGetAllCarInfoByCarInfoTypeSlug("vehicle-inventory");

  const defaultWorks = others?.defaultValues?.works;

  const worksLength = defaultWorks?.length;
  const haveAccessories = !!(worksLength > 0);

  const [fields, setFields] = useState([]);
  const [count, setCount] = useState(haveAccessories ? worksLength : 0);

  // function generate field
  const generateFields = useCallback(
    (item, index) => {
      const currentIndex = index;
      return [
        {
          label: `${currentIndex + 1}. Name`,
          name: `works.${index}.name`,
          type: "select",
          placeholder: "Select a name",
          col: { md: 4 },
          options: works,
          index
        },
        {
          label: "Remarks",
          name: `works.${index}.remarks`,
          type: "text",
          placeholder: "Remarks",
          col: { md: 3 },
          index
        },
        {
          name: `RemoveVehicleShowroomWorksField-${index}`,
          type: "custom",
          customComponent: RemoveVehicleShowroomWorksField,
          col: { md: 2 },
          others: { index, setFields },
          index
        }
      ];
    },
    [works]
  );

  // if have default value then call only one time generateFields
  useEffect(() => {
    function handleDefaultValue() {
      const initFields =
        (arrayMap(defaultWorks, (item, index) => generateFields(item, index)) || []).flat() ||
        undefined;

      if (initFields) {
        setFields(initFields);
      }
    }

    handleDefaultValue();
  }, [defaultWorks, generateFields, haveAccessories]);

  // handle add new additional cost
  const handleAdd = (index) => {
    const field = generateFields(null, index);
    setCount((prev) => prev + 1);
    setFields((prev) => [...prev, ...field]);
  };

  const isLoading = loading;

  return (
    <>
      <FormSectionContainer
        setValue={setValue}
        fields={fields}
        control={control}
        watch={watch}
        errors={errors}
        loading={isLoading}
        unregister={unregister}>
        {/* render additional cost title and add button */}
        <div className="row align-items-center mb-3">
          <div className="col-6">
            <FormSectionTitle>Works</FormSectionTitle>
            <p>{fields.length === 0 ? "To add works, click the 'Add' button." : ""}</p>
          </div>
          <div className="col-6">
            <div className="text-end">
              <Button onClick={() => handleAdd(count)} name="Add" icon={AddIcon} />
            </div>
          </div>
        </div>
      </FormSectionContainer>
    </>
  );
}
